import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import IvisoraLogo from '../shared/IvisoraLogo';
import { SUPPORT_EMAIL } from '../../content/sitePages';

// Only pages that exist. Social profiles, Help Center, Careers, Press,
// Partners and the tutorial/community links come back when they do.
const COLUMNS = [
  {
    title: 'Product',
    links: [
      ['Features', '/#features'],
      ['Templates', '/templates'],
      ['Marketplace', '/marketplace'],
      ['Pricing', '/pricing'],
      ['Editor', '/editor'],
      ['AI Tools', '/#ai-tools'],
    ],
  },
  {
    title: 'Company',
    links: [
      ['About Us', '/about'],
      ['Blog', '/blog'],
      ['Contact', '/contact'],
    ],
  },
  {
    title: 'Legal',
    links: [
      ['Privacy Policy', '/privacy'],
      ['Terms of Service', '/terms'],
      ['Cookie Policy', '/cookies'],
    ],
  },
];

const Footer = () => (
  <footer className="bg-gradient-to-br from-gray-900 via-purple-900 to-violet-900 text-white">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
        <div className="sm:col-span-2">
          <Link to="/" aria-label="iVisora — home" className="inline-flex items-center mb-4">
            <IvisoraLogo variant="white" className="h-8 sm:h-9 transition-opacity duration-200 hover:opacity-90" />
          </Link>
          <p className="text-gray-300 mb-5 max-w-sm">
            The AI-powered creative platform for creators, designers, editors, and content teams. Create without limits.
          </p>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="inline-flex items-center gap-2 text-gray-300 hover:text-white transition-colors"
          >
            <Mail className="w-4 h-4" aria-hidden="true" />
            {SUPPORT_EMAIL}
          </a>
        </div>

        {COLUMNS.map((col) => (
          <nav key={col.title} aria-label={col.title}>
            <h3 className="font-semibold mb-4">{col.title}</h3>
            <ul className="space-y-2">
              {col.links.map(([label, to]) => (
                <li key={to}>
                  <Link to={to} className="text-gray-300 hover:text-white transition-colors">{label}</Link>
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>

      <div className="border-t border-white/10 mt-12 pt-8">
        <p className="text-gray-400 text-sm">&copy; {new Date().getFullYear()} iVisora. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
